import { render } from "./AdminPanel.vue?vue&type=template&id=6a4a51e5"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"

import "./AdminPanel.vue?vue&type=style&index=0&id=6a4a51e5&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__